import { supabase } from './supabase';
import { getAuthToken } from './api';

/**
 * fetch verso le rotte riservate agli admin (/api/admin/*, scritture su /api/settings/*):
 * aggiunge il token della sessione Supabase, che il backend verifica (require_admin).
 * getSession rinnova il token se scaduto; in caso di problemi del client si usa
 * il token salvato in localStorage.
 */
export const getAdminAuthHeader = async () => {
  let token = null;
  try {
    const { data } = await supabase.auth.getSession();
    token = data?.session?.access_token || null;
  } catch (_) {
    /* fallback sotto */
  }
  if (!token) token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const adminFetch = async (url, options = {}) => {
  const authHeader = await getAdminAuthHeader();
  return fetch(url, {
    ...options,
    headers: { ...(options.headers || {}), ...authHeader },
  });
};

export default adminFetch;
